/* DEMO (29 Oct, v4): homepage 'big picture + top sellers' blocks. Puts them under Shop Top Categories, then fills each block with 6 products, asked for fresh on every page view: first any in-stock product carrying the block's pin tag (set in the Homepage feature entry, e.g. home-rio), then the collection's best sellers (Shopify's own best-selling order) to fill the rest. If nothing carries the pin tag Shopify redirects to the whole catalogue; that answer is ignored. A block with no products is removed. Also moves the 'Brands Who Put Their Trust in us' strip so it sits above the first block. */
(function () {
  'use strict';
  var tries = 0, MAX = 6;
  function get(url, ignoreRedirect) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok || (ignoreRedirect && r.redirected)) return '';
      return r.text();
    }).catch(function () { return ''; });
  }
  function cards(html) {
    var ul = document.createElement('ul');
    ul.innerHTML = html;
    return Array.prototype.slice.call(ul.children);
  }
  function key(li) { var b = li.querySelector('[data-proid]'); return b ? b.getAttribute('data-proid') : li.textContent; }
  function fill(sec) {
    var h = sec.getAttribute('data-handle'), tag = sec.getAttribute('data-tag');
    var q = '?sort_by=best-selling&view=dc-feature';
    var pinned = tag ? get('/collections/all/' + encodeURIComponent(tag) + q, true) : Promise.resolve('');
    Promise.all([pinned, get('/collections/' + encodeURIComponent(h) + q, false)]).then(function (res) {
      var seen = {}, out = [];
      cards(res[0]).concat(cards(res[1])).forEach(function (li) {
        var k = key(li);
        if (!seen[k] && out.length < MAX) { seen[k] = 1; out.push(li); }
      });
      if (!out.length) { sec.remove(); return; }
      var ul = sec.querySelector('.dc-fgrid');
      out.forEach(function (li) { ul.appendChild(li); });
    });
  }
  function place() {
    var tpl = document.getElementById('dc-feats-tpl');
    if (!tpl || document.querySelector('.dc-feat')) return;
    var anchor = document.getElementById('dc-cats');
    if (!anchor && tries < 30) { tries++; return setTimeout(place, 50); }
    anchor = anchor || document.getElementById('dc-popular') || document.getElementById('dc-hero') || document.getElementById('masthead');
    if (!anchor || !anchor.parentNode || !window.fetch) return;
    var frag = tpl.content.cloneNode(true);
    var secs = Array.prototype.slice.call(frag.querySelectorAll('.dc-feat'));
    var ref = anchor.nextSibling, parent = anchor.parentNode;
    var brands = document.getElementById('shopify-section-home-brands');
    if (brands) parent.insertBefore(brands, ref);
    secs.forEach(function (s) { parent.insertBefore(s, ref); });
    secs.forEach(fill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();